module.exports = __webpack_public_path__ + "img/blog.84e9da50.svg";